/**
 * Tile layers available on the logbook audit map.
 *
 * memomaps.de (ÖPNVKarte) allows use of its public tile server with attribution for low-traffic
 * sites; high-traffic sites must self-host (https://öpnvkarte.de, checked 2026-09-24). An
 * internal auditor page with a handful of users is well within that.
 *
 * Esri's World Imagery tiles are free to use with the attribution below (Esri basemap terms,
 * checked 2026-10-03); they only serve the small refuel-location map and the trip map on demand.
 */
export type MapTileId = "publicTransport" | "osm" | "satellite";

export interface MapTileLayer {
  id: MapTileId;
  url: string;
  attribution: string;
  maxZoom: number;
}

export const MAP_TILE_LAYERS: readonly MapTileLayer[] = [
  {
    id: "publicTransport",
    url: "https://tileserver.memomaps.de/tilegen/{z}/{x}/{y}.png",
    attribution:
      'Map <a href="https://memomaps.de/">memomaps.de</a> <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 18,
  },
  {
    id: "osm",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
  },
  {
    id: "satellite",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution:
      "Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community",
    maxZoom: 19,
  },
];

export const DEFAULT_MAP_TILE_ID: MapTileId = "publicTransport";
